import React, { useEffect, useRef, useState } from 'react';
import { Outlet } from 'react-router-dom';

import { Header } from './sub-components/header';
import { SideBar } from './sub-components/side-bar';
import { useSelectedStore } from '../../stores';

export const DefaultLayout2 = () => {
    const headerRef = useRef<HTMLDivElement>(null);
    const [headerHeight, setHeaderHeight] = useState(0);

    // 헤더 높이를 동적으로 측정하는 로직
    useEffect(() => {
        const headerElement = headerRef.current;
        if (!headerElement) {
            return;
        }

        const setHeight = () => setHeaderHeight(headerElement.offsetHeight);
        const observer = new ResizeObserver(setHeight);

        // 초기 높이 설정
        setHeight();
        // 크기 변경 관찰
        observer.observe(headerElement);

        return () => observer.disconnect();
    }, []);

    const { workspace } = useSelectedStore();
    const isWorkspaceSelected = !!workspace;

    return (
        <div className="bg-background w-full min-h-screen">
            <SideBar />
            <div className="min-h-screen flex flex-col w-full">
                <Header headerRef={headerRef} />
                <main
                    className={`flex-1 overflow-y-auto flex flex-col items-center max-h-screen ${
                        isWorkspaceSelected ? 'md:pl-[82px]' : ''
                    }`}
                    style={{ paddingTop: `${headerHeight}px` }}
                >
                    <Outlet />
                </main>
            </div>
        </div>
    );
};
